import type { ReactNode } from 'react';

/** A report section title: a quiet rule instead of a card around the section. */
export function SectionHeading({
  id,
  title,
  description,
}: {
  id: string;
  title: string;
  description?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1 border-b pb-2">
      <h3 id={id} className="text-base font-semibold tracking-tight">
        {title}
      </h3>
      {description && <div className="text-xs text-muted-foreground">{description}</div>}
    </div>
  );
}
